import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserPermissions } from '../../contexts/UserPermissionsContext';
import LoginButton from '../../components/auth/LoginButton';

function Home() {
  const { isAuthenticated, user } = useAuth0();
  const { isPending, isViewer } = useUserPermissions();

  return (
    <>
      {/* Hero Section */}
      <div className="hero-section">
        <Container className="text-center">
          <h1>Department of Social Services</h1>
          <p className="tagline">Central Government</p>
          <p className="lead">National CBR Program - Database Management System</p>
          <p>Empowering inclusion through comprehensive data management</p>
          {!isAuthenticated ? (   
            <>      
            {/* Sign-in prompt */}
            <div className="text-center mt-5">
              <LoginButton />
            </div>
            </>   
          ):(<></>)}
        </Container>
      </div>

      <Container style={{ minHeight: '60vh' }}>
        {isAuthenticated ? (
          <>
            {/* Welcome Message */}
            <div className="info-section">
              <p>Welcome <strong>{user?.name ? `, ${user.name}` : ''}!</strong></p>
              <p>
                You are signed in to the{' '}
                <strong>Department of Social Services, Sri Lanka</strong> National
                CBR Database Management System. Use the options below to search
                records, register new persons, or view analytics.
              </p>
              {isPending && (
                <p className="mb-0" style={{ color: '#b45309' }}>
                  <i className="bi bi-exclamation-triangle-fill me-1"></i> Your account is currently <strong>pending approval</strong>. Some
                  features may be restricted until an administrator grants you access.
                  Please contact{' '}
                  
                   <a href="mailto:director@socialservices.gov.lk"
                    className="contact-link"
                  >
                    director@socialservices.gov.lk
                  </a>{' '}
                  if you need assistance.
                </p>
              )}
            </div>

            {/* Action Cards */}
            <Row className="g-4 mb-5">
              <Col md={6} lg={3}>
                <Card className="card-action">
                  <Card.Body className="text-center p-4">
                    <div className="card-icon docs"><i className="bi bi-book-fill"></i></div>
                    <h5>Documentation</h5>
                    <p>Learn how to use the system with step-by-step guides</p>
                    <Link to="/docs" className="card-btn">View Docs</Link>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6} lg={3}>
                <Card className="card-action">
                  <Card.Body className="text-center p-4">
                    <div className="card-icon search"><i className="bi bi-search"></i></div>
                    <h5>Search Records</h5>
                    <p>Find and view existing person with disability records in the database</p>
                    <Link to="/search" className="card-btn">Search Now</Link>
                  </Card.Body>
                </Card>
              </Col>

              {!isViewer && (
                <Col md={6} lg={3}>
                  <Card className="card-action">
                    <Card.Body className="text-center p-4">
                      <div className="card-icon register"><i className="bi bi-pencil-square"></i></div>
                      <h5>Register New Person</h5>
                      <p>Add a new person with disability to the national database</p>
                      <Link to="/register" className="card-btn">Register</Link>
                    </Card.Body>
                  </Card>
                </Col>
              )}

              <Col md={6} lg={3}>
                <Card className="card-action">
                  <Card.Body className="text-center p-4">
                    <div className="card-icon analytics"><i className="bi bi-bar-chart-fill"></i></div>
                    <h5>View Analytics</h5>
                    <p>Access insights and statistics from the disability database</p>
                    <Link to="/analytics/select" className="card-btn">View Insights</Link>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        ) : (
          <>
            {/* Info Section for guests */}
            <div className="info-section">
              <h3>About This System</h3>
              <p>
                This platform is developed and maintained by the{' '}
                <strong>Department of Social Services, Sri Lanka</strong> to maintain
                a comprehensive database of persons with disabilities across the
                country. The system enables efficient registration, tracking, and
                analysis of disability-related data to support better policy-making
                and service delivery.
              </p>
              <p className="mb-0">
                <strong>For Government Officers:</strong> If you require access to
                dashboards and analytics, please contact the Department of Social
                Services at{' '}
                
                 <a href="mailto:director@socialservices.gov.lk"
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                >
                  director@socialservices.gov.lk
                </a>
              </p>
            </div>
          </>
        )}
      </Container>
    </>
  );
}

export default Home;